import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { UserObject } from '@client/graphql/__generated__/types';
import { LoginForm } from '~/services/main/components/auth/Login/LoginForm';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const VerifyUserModal = ({
  headingText = 'Verify your phone number',
  showVerifyUserModal,
  setShowVerifyUserModal,
  onSignup,
}: {
  headingText?: string;
  showVerifyUserModal: boolean;
  setShowVerifyUserModal: (value: boolean) => void;
  onSignup?: (user?: UserObject) => Promise<void>;
}) => {
  const { refetchUser } = useAppContext();

  const toast = useToast();
  const isOpen = showVerifyUserModal;
  const onClose = () => setShowVerifyUserModal(false);

  const onLogin = async (user?: UserObject) => {
    if (onSignup) {
      await onSignup(user);
    }
    toast({
      title: 'Verification Success',
      description: 'You have successfuly verified your phone number.',
      isClosable: true,
    });
    onClose();
    await refetchUser();
  };

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      size={{ base: 'md', md: 'lg' }}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        containerProps={{
          alignItems: 'center',
        }}
      >
        <ModalCloseButton />
        <ModalBody pt={6}>
          <VStack alignItems="flex-start" spacing={4}>
            <Heading size="heading">{headingText}</Heading>
            <Text>Please verify your phone number to continue</Text>

            <LoginForm onLogin={onLogin} />
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
